import { useState, useEffect } from 'react'
import { mySalesService } from '../Services/mySalesService'

export const useCoupons = () => {
  const [coupons, setCoupons] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchCoupons = async () => {
    try {
      setIsLoading(true)
      const data = await mySalesService.getCoupons()
      setCoupons(data)
    } catch (err) {
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchCoupons()
  }, [])

  const handleCreateCoupon = async (coupon) => {
    try {
      const response = await mySalesService.createCoupon(coupon)
      if (response?.status === 200) {
        await fetchCoupons()
      }
    } catch (err) {
      setError(err)
    }
  }

  const handleDeleteCoupon = async (id) => {
    try {
      const response = await mySalesService.deleteCoupon(id)
      if (response?.status === 200) {
        await fetchCoupons()
      }
    } catch (err) {
      setError(err)
    }
  }

  return {
    coupons,
    isLoading,
    error,
    isModalOpen,
    setIsModalOpen,
    handleCreateCoupon,
    handleDeleteCoupon,
  }
}
